/* SILNTPLAY — First Access signup (snippets/sl-signup-form).
   Same request as sections/sp-signup (Phase L.2 verified against the live
   endpoint): the POST itself is the consent action; do not add a
   'subscriptions' field to the profile (Klaviyo returns 400).
   On success it fires 'sl:subscribed' (bubbles) for the popup. */
(function () {
  'use strict';
  function init(form) {
    if (form.dataset.slInit) return;
    form.dataset.slInit = '1';
    var input = form.querySelector('input[name="email"]');
    var button = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-sl-msg]');
    var baseLabel = button.textContent;

    function say(text, isError) {
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.toggle('is-error', !!isError);
    }
    function reset() { button.disabled = false; button.textContent = baseLabel; }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (input.value || '').trim();
      if (email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
        say('Enter a valid email address.', true);
        input.focus();
        return;
      }
      button.disabled = true;
      button.textContent = 'Joining';
      msg.hidden = true;
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source || 'Website',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.ok) {
          form.querySelector('.sl-signup__row').hidden = true;
          say("You're in. Your First Access email is on its way.", false);
          form.dispatchEvent(new CustomEvent('sl:subscribed', { bubbles: true }));
        } else {
          reset();
          say('That did not go through. Try again, or email info@silntplay.com.', true);
        }
      }).catch(function () {
        reset();
        say('No connection. Check your network and try again, or email info@silntplay.com.', true);
      });
    });
  }
  function run() { document.querySelectorAll('[data-sl-signup]').forEach(init); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
